import { h } from "@stencil/core";

export const ModalForm = (options) => (
    <ux-modal
        close-on-esc-key="false"
        close-on-backdrop-click="true"
        name="software-updates-modal-form"
        opened={options.modalFormState}
        sticky-position="center"
    >
        <ux-modal-content>
            {(options.modalFormSpinnerGetState ||
                options.modalFormSpinnerPostState) && (
                <ux-spinner-overlay opened></ux-spinner-overlay>
            )}
            <ux-form onUxFormValidated={options.onFormValidated}>
                <form>
                    <div class="ux-row ux-u-mb-fluid-xxxs">
                        <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                            <h2 class="ux-text-headline ux-text-headline--gian ux-u-my-xs ux-u-text-align--center">
                                {options.translate("modalForm.headline")}
                            </h2>
                            <p class="ux-text-normal ux-u-mb-zero">
                                {options.translate("modalForm.copy.text1")}
                            </p>
                            <p class="ux-text-normal ux-u-mb-zero">
                                {options.translate("modalForm.copy.text2")}{" "}
                                <a
                                    class="ux-text-link ux-text-link--green"
                                    href={options.readMoreLink}
                                    target="_blank"
                                >
                                    {options.translate(
                                        "modalForm.copy.linkText"
                                    )}
                                </a>
                            </p>
                        </div>
                    </div>
                    <div>
                        <div class="ux-row ux-u-mb-fluid-xxxs">
                            <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                <label>
                                    {options.translate(
                                        "modalForm.machine.label"
                                    )}
                                </label>
                                <div
                                    class={`ux-text-normal ux-iws-software-updates-modal-dynamic ${
                                        !options.modalFormSpinnerGetState
                                            ? "ux-iws-software-updates-modal-dynamic--show"
                                            : ""
                                    }`}
                                >
                                    {options.machineName} (
                                    {options.machineNumber})
                                </div>
                            </div>
                        </div>
                        <div class="ux-row ux-u-mb-fluid-xxs">
                            <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                <div>
                                    <label>
                                        {options.translate(
                                            "modalForm.softwareUpdatesInput.label"
                                        )}
                                    </label>
                                    <ux-switch-input
                                        checked={options.softwareUpdateState}
                                        label={options.translate(
                                            "modalForm.softwareUpdatesInput.labelSwitchInput"
                                        )}
                                        label-placement="end"
                                        class={`ux-iws-software-updates-modal-dynamic ${
                                            !options.modalFormSpinnerGetState
                                                ? "ux-iws-software-updates-modal-dynamic--show"
                                                : ""
                                        }`}
                                    ></ux-switch-input>
                                    <input
                                        type="hidden"
                                        name="securityUpdateSubscribed"
                                        value={options.softwareUpdateState}
                                    />
                                    <input
                                        type="hidden"
                                        name="machineNumber"
                                        value={options.machineNumber}
                                    />
                                </div>
                            </div>
                        </div>
                        <div
                            class={`ux-row ux-u-flex-jc-between ${
                                !options.softwareUpdateState && "ux-u-d-none"
                            }`}
                        >
                            <div class="ux-col-12 ux-col-xl-10 ux-u-offset-xl-1">
                                <ux-checkbox
                                    class="ux-iws-software-updates__legal-checkbox"
                                    value={options.softwareUpdateState}
                                    name="acceptedLegalTerms"
                                    required={options.softwareUpdateState}
                                    data-validation-required--msg={options.translate(
                                        "modalForm.privacyPolicy.validationError"
                                    )}
                                >
                                    <span class="ux-text-normal ux-text-normal--light-gray">
                                        {options.translate(
                                            "modalForm.privacyPolicy.text"
                                        )}{" "}
                                        <a
                                            class="ux-text-link ux-text-link--green"
                                            href={options.privacyPolicyLink}
                                            target="_blank"
                                        >
                                            {options.translate(
                                                "modalForm.privacyPolicy.linkText"
                                            )}
                                        </a>
                                    </span>
                                </ux-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="ux-row ux-u-mt-fluid-xxs">
                        <div class="ux-col-12 ux-col-md-6 ux-col-xl-5 ux-u-offset-xl-1 ux-u-mb-xs ux-u-mb-md-zero">
                            <ux-button
                                type="button"
                                class="ux-u-w-100 ux-u-w-md-auto"
                                data-trigger-modal="close,software-updates-modal-form"
                            >
                                {options.translate("modalForm.buttons.cancel")}
                            </ux-button>
                        </div>
                        <div class="ux-col-12 ux-col-md-6 ux-col-xl-5 ux-u-d-md-flex ux-u-flex-jc-md-end">
                            <ux-button
                                type="submit"
                                class="ux-u-w-100 ux-u-w-md-auto"
                                variant="primary"
                            >
                                {options.translate("modalForm.buttons.submit")}
                            </ux-button>
                        </div>
                    </div>
                </form>
            </ux-form>
        </ux-modal-content>
    </ux-modal>
);

export const ModalMessageSuccess = (options) => (
    <ux-modal
        close-on-esc-key="false"
        close-on-backdrop-click="true"
        sticky-position="center"
        opened={options.modalMessageSuccessState}
        name="software-updates-modal-message-success"
    >
        <ux-modal-content>
            <div class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-dir-column">
                <span class="ux-color-success">
                    <ux-icon
                        name="checkmark"
                        weight="light"
                        size-s="50"
                        size-m="80"
                    ></ux-icon>
                </span>
                <h2 class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-mb-zero ux-color-success">
                    {options.translate("modalMessageSuccess.headline")}
                </h2>
                <ux-button
                    class="ux-u-mt-fluid-xxs"
                    data-trigger-modal="close,software-updates-modal-message-success"
                >
                    {options.translate("modalMessageSuccess.buttons.close")}
                </ux-button>
            </div>
        </ux-modal-content>
    </ux-modal>
);

export const ModalMessageError = (options) => (
    <ux-modal
        close-on-esc-key="false"
        close-on-backdrop-click="true"
        sticky-position="center"
        opened={options.modalMessageErrorState}
        name="software-updates-modal-message-error"
    >
        <ux-modal-content>
            <div class="ux-u-d-flex ux-u-flex-ai-center ux-u-flex-dir-column">
                <span class="ux-color-warning">
                    <ux-icon
                        name="triangle-warning"
                        weight="light"
                        size-s="50"
                        size-m="80"
                    ></ux-icon>
                </span>
                <h2 class="ux-text-headline ux-text-headline--big ux-u-text-align--center ux-u-mb-zero ux-color-warning">
                    {options.translate("modalMessageError.headline")}
                </h2>
                <ux-button
                    class="ux-u-mt-fluid-xxs"
                    data-trigger-modal="close,software-updates-modal-message-error"
                >
                    {options.translate("modalMessageError.buttons.close")}
                </ux-button>
            </div>
        </ux-modal-content>
    </ux-modal>
);
